/**
 * @file beforeUnloadGuard
 * @description 浏览器 beforeunload 短时跳过开关，用于下载等程序触发的离开场景
 */

const BEFORE_UNLOAD_SKIP_DURATION = 1500;

let skipBeforeUnloadTimer: ReturnType<typeof setTimeout> | null = null;
let skipBeforeUnloadUntil = 0;

export const skipBeforeUnloadOnce = (duration = BEFORE_UNLOAD_SKIP_DURATION) => {
    if (typeof window === 'undefined') {
        return;
    }
    skipBeforeUnloadUntil = Date.now() + duration;
    if (skipBeforeUnloadTimer) {
        clearTimeout(skipBeforeUnloadTimer);
    }
    skipBeforeUnloadTimer = setTimeout(() => {
        skipBeforeUnloadUntil = 0;
        skipBeforeUnloadTimer = null;
    }, duration);
};

export const shouldSkipBeforeUnload = () => Date.now() < skipBeforeUnloadUntil;
